import { render, staticRenderFns } from "./RoleManagementDetailInput.vue?vue&type=template&id=1356d0da&scoped=true&"
import script from "./RoleManagementDetailInput.vue?vue&type=script&lang=js&"
export * from "./RoleManagementDetailInput.vue?vue&type=script&lang=js&"
import style0 from "./RoleManagementDetailInput.vue?vue&type=style&index=0&id=1356d0da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1356d0da",
  null
  
)

export default component.exports